import React from 'react'
import { Alert, Container } from '@mui/material'
import * as S from './styles'
import { Box } from '@mui/system'

interface ContainerProps {
  height?: number | string
  maxWidth?: number | string
  title?: string
  error?: string
  success?: string
  paperPadding?: number | string
  marginTop?: number | string
  marginBottom?: number | string
  children: React.ReactNode
}

const CustomContainer: React.FC<ContainerProps> = ({
  height,
  maxWidth,
  title,
  error,
  success,
  paperPadding,
  marginTop,
  marginBottom,
  children
}: ContainerProps) => {
  return (
    <Container
      maxWidth={false}
      sx={{
        height: height || 'auto',
        maxWidth: maxWidth || '550px',
        marginTop: marginTop !== undefined ? marginTop : '90px',
        marginBottom: marginBottom !== undefined ? marginBottom : '60px'
      }}
    >
      {title && (
        <S.Title variant="h4" textAlign="center">
          {title}
        </S.Title>
      )}
      <S.StyledPaper variant="card" paperPadding={paperPadding} sx={{ height: height && !title ? '100%' : 'auto' }}>
        {(error || success) && (
          <Box mb="24px" maxWidth="550px">
            <Alert severity={error ? 'error' : 'success'}>{error || success}</Alert>
          </Box>
        )}
        {children}
      </S.StyledPaper>
    </Container>
  )
}

export default CustomContainer
